import src from "IMAGE";
export default { src, width: 23, height: 14, blurWidth: 0, blurHeight: 0};
